import marketingBR from './marketing.br';
import marketingCL from './marketing.cl';
import marketingCO from './marketing.co';
import marketingMX from './marketing.mx';

const locales = {
  BR: marketingBR,
  CL: marketingCL,
  CO: marketingCO,
  MX: marketingMX,
};

export default locales;
